export default ()=>{
    const dropdownContainers = document.querySelectorAll('[dropdown-container]');

    dropdownContainers.forEach(wrapper =>{
        const button = wrapper.querySelector('[dropdown-button]');

        const elements = wrapper.querySelectorAll('[dropdown-element]');

        button.addEventListener('click', ()=>{
            button.classList.toggle('open')
            elements.forEach(element =>{
                element.classList.toggle('open')
            })
        })
    })
}